import HGLink from '../index'
import { LinkProps } from '../links.types'

export default function LinkAbout({ children, href, ...props }: LinkProps) {
  return (
    <HGLink href={href || '/about'} aria-label='go to about' {...props}>
      {children}
    </HGLink>
  )
}
